export default __webpack_public_path__ + "static/media/ultima-etapa-mobile.008b1166.webp";